export default "__VITE_ASSET__Cc6t0YUe__"